import React, { useEffect, useRef, useState } from 'react';
import css from './style.module.css';

export default function OrgSelector({ organizations, selected, onSelect }) {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const containerRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        const handleOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        const handleEscape = (e) => {
            if (e.key === 'Escape') setOpen(false);
        };
        document.addEventListener('mousedown', handleOutside);
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('mousedown', handleOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [open]);

    const term = search.trim().toLowerCase();
    const filtered = term
        ? organizations.filter((org) => org.companyName?.toLowerCase().includes(term))
        : organizations;

    const handlePick = (org) => {
        setOpen(false);
        setSearch('');
        onSelect(org);
    };

    return (
        <div className={css.orgPicker} ref={containerRef}>
            <label className={css.orgPickerLabel}>Organization</label>
            <button
                type="button"
                className={css.orgPickerButton}
                onClick={() => setOpen((prev) => !prev)}
                aria-haspopup="listbox"
                aria-expanded={open}
            >
                {selected ? (
                    <>
                        {selected.logo && (
                            <img className={css.orgLogo} src={selected.logo} alt="" />
                        )}
                        <span>{selected.companyName}</span>
                    </>
                ) : (
                    <span className={css.orgPickerPlaceholder}>Select an organization…</span>
                )}
                <i className={`fa-solid fa-chevron-down ${css.orgCaret}`} aria-hidden="true"></i>
            </button>

            {open && (
                <div className={css.orgDropdown} role="listbox">
                    <input
                        type="text"
                        className={css.orgSearchInput}
                        placeholder="Search organizations…"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        autoFocus
                    />
                    <div className={css.orgList}>
                        {filtered.length === 0 ? (
                            <div className={css.orgEmpty}>No matching organizations</div>
                        ) : (
                            filtered.map((org) => (
                                <button
                                    key={org.id}
                                    type="button"
                                    role="option"
                                    aria-selected={selected?.id === org.id}
                                    className={`${css.orgOption} ${selected?.id === org.id ? css.orgOptionSelected : ''}`}
                                    onClick={() => handlePick(org)}
                                >
                                    {org.logo && <img className={css.orgLogo} src={org.logo} alt="" />}
                                    <span>{org.companyName}</span>
                                </button>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
